"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _FlightDetails = _interopRequireDefault(require("./FlightDetails.proptypes"));
var _constant = require("./constant");
var DefaultFlightDetailsWrapper = _styledComponents.default.div.withConfig({
  displayName: "FlightDetails__DefaultFlightDetailsWrapper",
  componentId: "sc-14id31h-0"
})([""]);
DefaultFlightDetailsWrapper.displayName = 'DefaultFlightDetailsWrapper';
var StationInfoBody = _styledComponents.default.div.withConfig({
  displayName: "FlightDetails__StationInfoBody",
  componentId: "sc-14id31h-1"
})(["font-size:", ";display:flex;align-items:center;"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSize.normal;
});
StationInfoBody.displayName = 'StationInfoBody';
var FlightSummaryBody = _styledComponents.default.div.withConfig({
  displayName: "FlightDetails__FlightSummaryBody",
  componentId: "sc-14id31h-2"
})(["font-size:", ";display:flex;align-items:center;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSize.normal;
});
FlightSummaryBody.displayName = 'FlightSummaryBody';
var StationContainer = _styledComponents.default.div.withConfig({
  displayName: "FlightDetails__StationContainer",
  componentId: "sc-14id31h-3"
})(["color:", ";font-family:", ";font-weight:", ";font-size:", ";line-height:", ";display:flex;align-items:center;flex-wrap:wrap;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.neutral;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontFamily.default;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeight.medium;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSize.small;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.lineHeight.normal;
});
var AirlineLogoContainer = _styledComponents.default.div.withConfig({
  displayName: "FlightDetails__AirlineLogoContainer",
  componentId: "sc-14id31h-4"
})(["margin-right:", ";width:", ";height:", ";min-width:", ";display:flex;align-items:center;justify-content:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.XXXSmall;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.standard;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.space.standard;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.standard;
}, function (_ref12) {
  var isSecondAirline = _ref12.isSecondAirline;
  return isSecondAirline ? 'flex-end' : 'flex-start';
});
var Airlinelogo = _styledComponents.default.img.withConfig({
  displayName: "FlightDetails__Airlinelogo",
  componentId: "sc-14id31h-5"
})(["width:", ";"], function (_ref13) {
  var showSecondAirline = _ref13.showSecondAirline;
  return showSecondAirline ? '65%' : '100%';
});
var SecondAirlinelogo = _styledComponents.default.img.withConfig({
  displayName: "FlightDetails__SecondAirlinelogo",
  componentId: "sc-14id31h-6"
})(["width:65%;"]);
var ArrowIconContainer = _styledComponents.default.div.withConfig({
  displayName: "FlightDetails__ArrowIconContainer",
  componentId: "sc-14id31h-7"
})(["display:flex;align-items:center;justify-content:space-between;width:25px;color:", ";padding:0 3px;"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.greyDark;
});
var FlightDetailsContainer = _styledComponents.default.span.withConfig({
  displayName: "FlightDetails__FlightDetailsContainer",
  componentId: "sc-14id31h-8"
})(["color:", ";font-size:", ";font-family:", ";font-weight:", ";font-weight:", ";"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.greyDark;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontSize.XSmall;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.fontFamily.default;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.fontWeight.normal;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontWeight.normal;
});
var FlightDetails = function FlightDetails(props) {
  var accessible = props.accessible,
    theme = props.theme,
    data = props.data;
  var DefaultAirlineLogo = /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: true,
    color: _constant.ICON_TYPE.normal.color,
    customProperties: {
      id: 'icon-id'
    },
    fontsize: data && data.showSecondAirline ? _constant.ICON_TYPE.small.size : _constant.ICON_TYPE.normal.size,
    icon: "FlightIcon",
    theme: theme
  });
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(DefaultFlightDetailsWrapper, {
    tabIndex: !accessible ? '-1' : '0'
  }, /*#__PURE__*/_react.default.createElement(StationInfoBody, null, /*#__PURE__*/_react.default.createElement(AirlineLogoContainer, null, data.airlineLogo ? /*#__PURE__*/_react.default.createElement(Airlinelogo, {
    showSecondAirline: data.showSecondAirline,
    src: data.airlineLogo,
    alt: "Airline logo"
  }) : DefaultAirlineLogo), /*#__PURE__*/_react.default.createElement(StationContainer, null, /*#__PURE__*/_react.default.createElement("span", null, data.departStation), /*#__PURE__*/_react.default.createElement(ArrowIconContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: false,
    icon: "ArrowRightAltIcon",
    fontsize: _constant.ICON_TYPE.large.size,
    color: _constant.ICON_TYPE.normal.color
  })), /*#__PURE__*/_react.default.createElement("span", null, data.arriveStation))), /*#__PURE__*/_react.default.createElement(FlightSummaryBody, null, /*#__PURE__*/_react.default.createElement(AirlineLogoContainer, {
    isSecondAirline: true
  }, data.showSecondAirline && (data.secondAirlineLogo ? /*#__PURE__*/_react.default.createElement(SecondAirlinelogo, {
    src: data.secondAirlineLogo,
    alt: "Second Airline Logo"
  }) : DefaultAirlineLogo)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(FlightDetailsContainer, null, data.departDay, ", ", data.departDate), /*#__PURE__*/_react.default.createElement(FlightDetailsContainer, null, " | "), /*#__PURE__*/_react.default.createElement(FlightDetailsContainer, null, data.departTime, " - ", data.arriveTime), /*#__PURE__*/_react.default.createElement(FlightDetailsContainer, null, " | "), /*#__PURE__*/_react.default.createElement(FlightDetailsContainer, null, " ", data.flightType, " ")))));
};
FlightDetails.propTypes = _FlightDetails.default.PropTypes;
FlightDetails.defaultProps = _FlightDetails.default.DefaultProps;
var _default = FlightDetails;
exports.default = _default;